import { isThisYear, isToday } from 'date-fns';

export function getTimestampDateFormat(timestamp: Date) {
    if (isToday(timestamp)) return 'h:mmaaa';
    if (isThisYear(timestamp)) return 'MMM d h:mmaaa';
    return 'dd-MM-yyyy h:mmaaa';
}
